document.addEventListener('click', function(e) {
  const trigger = e.target.closest('.renewed-sidebar-trigger');
  const closeButton = e.target.closest('#wefurb-sidebar-close');
  const overlayClick = e.target.closest('#wefurb-sidebar-overlay');

  const sidebar = document.getElementById('wefurb-sidebar');
  const content = document.getElementById('wefurb-sidebar-content');
  const overlay = document.getElementById('wefurb-sidebar-overlay');

  if (trigger) {
    e.preventDefault();

    if (sidebar && content) {
      sidebar.classList.add('open');
      if (overlay) overlay.classList.add('open');

      content.innerHTML = '<div style="text-align:center;padding:50px;">Loading...</div>';

      fetch('/pages/what-is-renewed')
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const main =
            doc.querySelector('.main-page-content') ||
            doc.querySelector('.rte') ||
            doc.querySelector('#MainContent') ||
            doc.body;

          content.innerHTML = main.innerHTML;
        })
        .catch(() => {
          content.innerHTML = '<p style="padding:20px;">Error loading content.</p>';
        });
    } else {
      window.location.href = '/pages/what-is-renewed';
    }

    return;
  }

  if (closeButton || overlayClick) {
    if (sidebar) sidebar.classList.remove('open');
    if (overlay) overlay.classList.remove('open');
  }
});

document.addEventListener('DOMContentLoaded', function() {
    const sidebarContainer = document.getElementById('wefurb-condition-guide-container');
    if (!sidebarContainer) return;

    let originalContentElement = null;

    document.body.addEventListener('click', async function(e) {
        const target = e.target;

        if (target.matches('.wefurb-condition-guide-trigger')) {
            e.preventDefault();
            const pageHandle = target.dataset.pageHandle;
            if (pageHandle) await openSidebar(pageHandle);
        }
        if (target.matches('.wefurb-condition-guide-close') || target.matches('.wefurb-condition-guide-overlay')) {
            closeSidebar();
        }
        if (target.matches('.device-tab')) {
            handleDeviceTabClick(target);
        }
        if (target.matches('.condition-tab')) {
            handleConditionTabClick(target);
        }
        if (target.matches('.sidebar-thumbnail-img')) {
            handleThumbnailClick(target);
        }
    });

    async function openSidebar(pageHandle) {
              sidebarContainer.innerHTML = '';

        try {
            const response = await fetch(`/pages/${pageHandle}`);
            const htmlString = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(htmlString, 'text/html');
            const pageContent = doc.querySelector('.shopify-policy__body, .rte, #main-content, #PageContent');

            if (!pageContent) throw new Error('Could not find main content area.');
            
            originalContentElement = pageContent;
                   renderFullSidebarStructure();
                      renderDeviceContent(0);

sidebarContainer.classList.add('is-open');
document.body.classList.add('wefurb-condition-guide-is-open');

        } catch (error) {
            sidebarContainer.innerHTML = '<div class="wefurb-condition-guide-error">Could not load content.</div>';
        }
    }

    function closeSidebar() {
        sidebarContainer.classList.remove('is-open');
        document.body.classList.remove('wefurb-condition-guide-is-open');
        originalContentElement = null;
    }

    function renderFullSidebarStructure() {
        const deviceWrappers = originalContentElement.querySelectorAll('.device-content-wrapper');
        const deviceTabsHTML = Array.from(deviceWrappers).map((wrapper, index) => {
            const deviceName = wrapper.dataset.device || `Device ${index + 1}`;
            return `<button class="wefurb-condition-guide-tab device-tab ${index === 0 ? 'is-active' : ''}" data-device-index="${index}">${deviceName}</button>`;
        }).join('');

        sidebarContainer.innerHTML = `
            <div class="wefurb-condition-guide-overlay"></div>
            <div class="wefurb-condition-guide-sidebar">
                <div class="wefurb-condition-guide-header">
                    <h2>Condition Details</h2>
                    <button class="wefurb-condition-guide-close">&times;</button>
                </div>
                <div class="wefurb-condition-guide-tabs device-tabs">${deviceTabsHTML}</div>
                <div class="wefurb-condition-guide-body"></div>
            </div>
        `;
    }

    function renderDeviceContent(deviceIndex) {
        const deviceWrappers = originalContentElement.querySelectorAll('.device-content-wrapper');
        const deviceWrapper = deviceWrappers[deviceIndex];
        if (!deviceWrapper) return;

        const sidebarBody = sidebarContainer.querySelector('.wefurb-condition-guide-body');
        
        const galleryElement = deviceWrapper.querySelector('.sidebar-image-gallery');
        let galleryHTML = '';
        if (galleryElement) {
            const images = Array.from(galleryElement.querySelectorAll('img'));
            const thumbnailsHTML = images.map(img => `<img src="${img.src}" alt="${img.alt}" class="sidebar-thumbnail-img">`).join('');
            galleryHTML = `
                <div class="sidebar-gallery-container">
                    <div class="sidebar-main-image"><img src="${images.length > 0 ? images[0].src : ''}" alt="Main view"></div>
                    <div class="sidebar-thumbnails">${thumbnailsHTML}</div>
                </div>`;
        }

        let conditionTabsHTML = '';
        let conditionPanelsHTML = '';
        const conditionsWrapper = deviceWrapper.querySelector('.all-conditions-wrapper');
        if (conditionsWrapper) {
            const conditionSections = conditionsWrapper.innerHTML.split('<!-- [split] -->').filter(s => s.trim());
            conditionSections.forEach((sectionHTML, index) => {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = sectionHTML;
                const title = tempDiv.querySelector('h3')?.innerText || `Condition ${index + 1}`;
                conditionTabsHTML += `<button class="wefurb-condition-guide-tab condition-tab ${index === 0 ? 'is-active' : ''}" data-condition-index="${index}">${title}</button>`;
                conditionPanelsHTML += `<div class="wefurb-condition-guide-panel condition-panel ${index === 0 ? 'is-active' : ''}" data-condition-panel-index="${index}">${sectionHTML}</div>`;
            });
        }

        sidebarBody.innerHTML = `
            ${galleryHTML}
            <div class="wefurb-condition-guide-tabs condition-tabs">${conditionTabsHTML}</div>
            <div class="condition-panels-container">${conditionPanelsHTML}</div>
        `;
    }

    function handleDeviceTabClick(tabElement) {
        const deviceIndex = tabElement.dataset.deviceIndex;
        sidebarContainer.querySelectorAll('.device-tab').forEach(t => t.classList.remove('is-active'));
        tabElement.classList.add('is-active');
        renderDeviceContent(deviceIndex);
    }

    function handleConditionTabClick(tabElement) {
        const conditionIndex = tabElement.dataset.conditionIndex;
        const container = tabElement.closest('.wefurb-condition-guide-body');
        container.querySelectorAll('.condition-tab').forEach(t => t.classList.remove('is-active'));
        tabElement.classList.add('is-active');
        container.querySelectorAll('.condition-panel').forEach(p => p.classList.remove('is-active'));
        container.querySelector(`.condition-panel[data-condition-panel-index="${conditionIndex}"]`).classList.add('is-active');
    }

    function handleThumbnailClick(thumbElement) {
        const mainImage = thumbElement.closest('.sidebar-gallery-container').querySelector('.sidebar-main-image img');
        if (mainImage) mainImage.src = thumbElement.src;
    }
});


document.addEventListener('change', function(e) {
  if (!e.target.matches('input[name="Condition"]')) return;

  const description = e.target.closest('variant-button')?.querySelector('[data-condition-description]');
  if (!description) return;

  const descriptions = {
    'New': 'Brand New Phone',
    'Premium': 'Condition: Like New Phone • 95%+ Battery Health',
    'Excellent': 'Condition: Like New Phone • 90%+ Battery Health',
    'Very Good': 'Condition: Like New Phone • 85%+ Battery Health'
  };

  description.textContent = descriptions[e.target.value] || '';
});
